import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 8) return setError("Le mot de passe doit contenir au moins 8 caractères.");
    if (form.password !== form.confirm) return setError("Les mots de passe ne correspondent pas.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: form.password });
      toast.success("Mot de passe réinitialisé. Vous pouvez vous connecter.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 text-center">
        <div className="bg-white border border-slate-200 rounded-2xl p-8 max-w-md">
          <p className="text-slate-700">Lien invalide. <a href="/forgot-password" className="text-emerald-600 hover:underline">Demander un nouveau lien</a></p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-emerald-500 flex items-center justify-center mb-4"><ShieldCheck className="w-8 h-8 text-black" /></div>
          <h1 className="font-heading text-2xl font-extrabold text-slate-900">Nouveau mot de passe</h1>
        </div>
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-5" data-testid="reset-form">
          <div className="space-y-2">
            <Label className="text-slate-700">Nouveau mot de passe</Label>
            <Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="reset-password" className="bg-slate-50 border-slate-200 h-11" />
          </div>
          <div className="space-y-2">
            <Label className="text-slate-700">Confirmer</Label>
            <Input type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required data-testid="reset-confirm" className="bg-slate-50 border-slate-200 h-11" />
          </div>
          {error && <div className="text-sm text-red-600 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">{error}</div>}
          <Button type="submit" disabled={loading} data-testid="btn-reset" className="w-full h-11 bg-emerald-500 hover:bg-emerald-600 text-black font-semibold">
            {loading && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Réinitialiser
          </Button>
        </form>
      </div>
    </div>
  );
}
